/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Risk Modelling Platform API
 * The API for the risk modelling platform
 * OpenAPI spec version: 1.0
 */

export type AppWeatherPackageRelationshipObjectAllOfDataType =
  (typeof AppWeatherPackageRelationshipObjectAllOfDataType)[keyof typeof AppWeatherPackageRelationshipObjectAllOfDataType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AppWeatherPackageRelationshipObjectAllOfDataType = {
  weatherpackage: "weatherpackage",
} as const;
